var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTasks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.3 10.2c1 0 1.7-.8 1.7-1.7V3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v44a3 3 0 0 0 3 3h44a3 3 0 0 0 3-3V16.9a1.7 1.7 0 0 0-3.5 0v29.7h-43v-43h43v5c0 1 .8 1.7 1.8 1.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 15.6a2.2 2.2 0 0 0 0-4.4 2.2 2.2 0 0 0 0 4.4zM11.8 27.2a2.2 2.2 0 0 0 0-4.4 2.2 2.2 0 0 0 0 4.4zM11.8 38.8a2.2 2.2 0 0 0 0-4.4c-1.2 0-2.2 1-2.2 2.2 0 1.2 1 2.2 2.2 2.2zM40.4 11.7h-4a1.7 1.7 0 0 0 0 3.5h4c1 0 1.8-.9 1.8-1.8 0-1-.8-1.7-1.8-1.7zM18.6 15.2H28c1 0 1.8-.8 1.8-1.8s-.8-1.7-1.8-1.7h-9.6c-1 0-1.7.8-1.7 1.8s.8 1.7 1.8 1.7zM18.6 35c-1 0-1.8.8-1.8 1.7 0 1 .8 1.8 1.8 1.8h4.3a1.7 1.7 0 0 0 0-3.5h-4.3zM40.4 35h-8.9c-1 0-1.7.8-1.7 1.8s.7 1.7 1.7 1.7h9c1 0 1.7-.7 1.7-1.7s-.8-1.7-1.8-1.7zM40.4 23.2l-21.9.1a1.7 1.7 0 0 0 0 3.5h22c.9 0 1.6-.9 1.6-1.8 0-1-.7-1.8-1.7-1.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.ef068595.svg";
export { ForwardRef as ReactComponent };